import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import classnames from 'classnames'
import CountdownTimer from '../../CountdownTimer'
import keyUpHandler from '../../../utils/keyUpHandler'
import { bannerPropType } from '..'
import './styles.css'

function BannerSlide({
  asset,
  countdownDate,
  link,
  ctaUrl,
  ctaLabel,
  title,
  description,
  hasGradient,
  video,
  videoThumbnail = null,
  displayVideo = () => {},
  onClickCTA = () => {}
}) {

  const withTimer = !_.isNull(countdownDate)

  return (
    <div
      className={classnames('banner-slide', { linkable: !_.isNull(link) })}
      style={{ backgroundImage: `url(${asset.original})` }}
      onClick={onClickCTA}
      onKeyUp={(event) => keyUpHandler(event, onClickCTA)}
      tabIndex={0}
      role="button"
    >
      {_.isNull(ctaUrl) && (
        <div className="overlay gradient">
          {!_.isNull(link) && (
            <a aria-label={title} href={link}>
              {' '}
            </a>
          )}
        </div>
      )}
      {!_.isNull(ctaUrl) && (
        <a
          aria-label={title}
          className={classnames('overlay', { gradient: hasGradient })}
          href={ctaUrl}
        >
          {' '}
        </a>
      )}
      <div className="wrapper">
        <div className="banner-info">
          <div className={classnames('title', { expand: !withTimer })}>
            {title}
          </div>
          <div className={classnames('description', { expand: !withTimer })}>
            <p>{description}</p>
          </div>
          {withTimer && (
            <div className="countdown">
              <CountdownTimer
                targetDate={countdownDate}
                startDelay={2000}
                interval={1000}
                leadingZero
              />
            </div>
          )}
          {!_.isNull(ctaLabel) && !_.isNull(ctaUrl) && (
            <div className="cta">
              <a href={ctaUrl}>
                <button type="button" className="btn -thin -orange">{ctaLabel}</button>
              </a>
            </div>
          )}
        </div>
        {video && videoThumbnail && (
          <div
            aria-labelledby="video-cta-label"
            className="video-banner"
            onClick={() => displayVideo(video)}
            onKeyUp={(event) => keyUpHandler(event, displayVideo, null, null, video)}
            tabIndex={0}
            role="button"
          >
            <div
              className="video-banner__thumb"
              style={{ backgroundImage: `url(${videoThumbnail})` }}
            >
              <div className="video-cta">
                <i className="icon-play video-cta__icon" />
                <span className="video-cta__text" id="video-cta-label">
                  Learn more
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

BannerSlide.propTypes = {
  ...bannerPropType,
  displayVideo: PropTypes.func,
  onClickCTA: PropTypes.func,
  videoThumbnail: PropTypes.string
}

export default BannerSlide
